import $ from 'jquery';
window.jQuery = $; window.$ = $;

require('./inc/modernizr.min.js');
require('./inc/plugins.js');
require('./inc/global.js');
require('./inc/forms.js');
require('./inc/pagebuilder.js');
require('./inc/rmicrofibre-landing.js');